import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DynamicReportGeneralListComponent } from './dynamic-report-general-list.component';

const routes: Routes = [
    {
        path: '',
        component: DynamicReportGeneralListComponent,
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class DynamicReportGeneralListRoutingModule { } 